import { render, staticRenderFns } from "./RumourEditor.vue?vue&type=template&id=6f851448"
import script from "./RumourEditor.vue?vue&type=script&lang=js"
export * from "./RumourEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f851448')) {
      api.createRecord('6f851448', component.options)
    } else {
      api.reload('6f851448', component.options)
    }
    module.hot.accept("./RumourEditor.vue?vue&type=template&id=6f851448", function () {
      api.rerender('6f851448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rumour/RumourEditor.vue"
export default component.exports